import React from "react";

// import { BsTelephoneFill } from "react-icons/bs";
// import { FaAddressBook } from "react-icons/fa";
// import { BsFileEarmarkBarGraph } from "react-icons/bs";
// import { BsTelephone } from "react-icons/bs";
// import GaugeChart from "react-gauge-chart";
// import Head from "./Head";

import { NavLink } from "react-router-dom";

import VisibilityIcon from "@mui/icons-material/Visibility";
const BulkedUpload = ({ data }) => {
  const Bulked = JSON.parse(data.Bulked);

  return (
    <div className="singleCustomer" id="Bulked">
      {/* <div className="customerHead">
          <div>
            <h3>{agentData[0]?.Agent_Name}</h3>
            <p>Agent</p>
          </div>
          <ul>
            <li>
              <span>
                <BsTelephoneFill />
              </span>
              <span>+92 300 1111111</span>
            </li>
            <li>
              <span>
                <FaAddressBook />
              </span>
              <span>156-T Main Street, New York, USA</span>
            </li>
          </ul>
        </div> */}

      {/* <div className="customerMid">
          <div className="salesSection">
            <Head heading="Sales and Services" />

            <ul className="salesContent">
              <li>
                <span>
                  <span className="icon">
                    {" "}
                    <BsFileEarmarkBarGraph />{" "}
                  </span>
                  <span className="content">
                    <span>{topics ? topics[0] : ""}</span>
                    <span>Time . New York</span>
                  </span>
                </span>
                <span>89.80%</span>
              </li>
              <li>
                <span>
                  <span className="icon secIcon">
                    {" "}
                    <BsTelephone />{" "}
                  </span>
                  <span className="content">
                    <span>Total Calls</span>
                    <span>Time . New York</span>
                  </span>
                </span>
                <span>{agentData[0]?.Total_Calls}</span>
              </li>
            </ul>
          </div>
          <div className="chartSection">
            <Head heading="Agent Performance" key="Agent Performance" />
            <div>
              <p className="normal">{agentData[0]?.Agent_Performance}%</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="100%"
                height="100%"
                viewBox="-10 -10 220 220"
                className="normal"
              >
                <circle className="center track" cx="50" cy="50" r="70" />

                <circle
                  className="center filled"
                  cx="50"
                  cy="50"
                  r="70"
                  strokeDasharray={String(
                    agentData[0]?.Agent_Performance * 4.4
                  )}
                />
              </svg>
            </div>
          </div>
          <div className="chartSection">
            <Head heading="Customer Satisfaction" key="Customer Satisfaction" />

            <GaugeChart
              id="gauge-chart"
              nrOfLevels={10}
              textColor="transparent"
              colors={["red", "yellow", "green"]}
              percent={Number.parseFloat(
                (
                  agentData[0]?.Customer_Satisfaction /
                  agentData[0]?.Total_Calls
                ).toFixed(2)
              )}
            ></GaugeChart>
            <p className="offset">
              {(
                (agentData[0]?.Customer_Satisfaction /
                  agentData[0]?.Total_Calls) *
                100
              ).toFixed()}
              %
            </p>
          </div>
          <div className="topics">
            <h3>Top Topics (All Calls)</h3>
            <div className="line"></div>
            <ul>
              {topics?.map((topic, index) => {
                return <li key={index}>{topic}</li>;
              })}
            </ul>
          </div>
        </div> */}

      <div className="customerBottom">
        <div className="summery">
          <table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Anger</th>
                <th>Sadness</th>
                <th>Excitement</th>
                <th>Satisfaction</th>
                <th>Empathy</th>
                <th>Friendliness</th>
                <th>Admiration</th>
                <th>Understanding</th>
                <th>Engagement</th>
                <th>Stress</th>
                <th>Confidence</th>
                <th>Professionalism</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {Bulked?.map((item, index) => {
                let emotions = JSON.parse(
                  item.AgentEmotions.replace(/'/g, '"')
                );
                return (
                  <tr key={index}>
                    <td>{item.TranscriptID}</td>
                    <td>{emotions.Agent_Anger.toFixed(4)}</td>
                    <td>{emotions.Agent_Sadness.toFixed(4)}</td>
                    <td>{emotions.Agent_Excitement.toFixed(4)}</td>
                    <td>{emotions.Agent_Satisfaction.toFixed(4)}</td>
                    <td>{emotions.Agent_Empathy.toFixed(4)}</td>
                    <td>{emotions.Agent_Friendliness.toFixed(4)}</td>
                    <td>{emotions.Agent_Admiration.toFixed(4)}</td>
                    <td>
                      {emotions["Agent_Understanding/Anticipation"].toFixed(4)}
                    </td>
                    <td>{emotions.Agent_Engagement.toFixed(4)}</td>
                    <td>{emotions.Agent_Stress.toFixed(4)}</td>
                    <td>{emotions.Agent_Confidence.toFixed(4)}</td>
                    <td>{emotions.Agent_Professionalism.toFixed(4)}</td>
                    <td>
                      <NavLink to={"/transcript"} state={{ data: item }}>
                        <VisibilityIcon />
                      </NavLink>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BulkedUpload;
